import React from "react";
import { List } from "antd";

const ContentListComponent = ({ header, items }) => {
  return (
    <>
      <List
        size="small"
        header={header}
        bordered
        dataSource={items}
        renderItem={(item) => <List.Item>{item}</List.Item>}
        style={{ marginBottom: "15px" }}
      />
    </>
  );
};

export default ContentListComponent;
